import { ChevronRight } from "lucide-react";
import { stepName } from "../lib/pointing";
import { FIELDS } from "./ContentView";
import type { PointPath } from "./PreviewFrame";

interface PointTrailProps {
  path: PointPath;
  /** Selects a level above, e.g. the whole card instead of its photo. */
  onStep: (depth: number) => void;
  /** Names the popover it heads. */
  id?: string;
}

/** What Point to change selected, from the section down; the levels above can be selected instead. */
export function PointTrail({ path, onStep, id }: PointTrailProps) {
  const steps = path.steps.slice(0, path.depth + 1);
  return (
    <nav className="bw-point-trail" aria-label="What you selected">
      {steps.map((step, index) => {
        const name = stepName(step, FIELDS);
        if (index === path.depth) return <strong key={index} id={id}>{name}</strong>;
        return (
          <span key={index} className="bw-point-step">
            <button type="button" onClick={() => onStep(index)} aria-label={`Select ${name} instead`}>{name}</button>
            <ChevronRight size={14} aria-hidden="true" />
          </span>
        );
      })}
    </nav>
  );
}
